import { CreateUpload } from "@coworker/apprestructured/src/task-management/types/Upload";

export type Comment = {
  title: string;
  text: string;
  created_at: string;
  creator_user_id: string;
  id: string;
  task_id: string;
  image_ids: string[];
  updated_at: string;
};

export type CreateComment = {
  task_id: string;
  text: string;
  images: CreateUpload[];
  title: string;
  creator_user_id: string;
};

export const MAX_COMMENT_TEXT_LENGTH = 255;
